export const environment = {
  production: false,
  apiUrl: "https://admin.niceproject.eu",
  apiGatewayUrl:
    "https://4a1nh2d5vc.execute-api.eu-central-1.amazonaws.com/api",
  apiGatewayKey: "np-dev-api-key-2025-change-me-in-production",
  captchaKey: "6LdCE1YcAAAAAOOgSA-VcwNuWfkklKgE9YdQZ9Ql",
};
